import { EmployeeNotificationSettingsDto } from '../../api/gen';

const centerLabel = $localize`:@@notificationSettingsCenter:Benachrichtigungscenter`;

export const notificationChannels = [
  {
    key: 'emailEnabled',
    icon: 'mail_outline',
    label: $localize`:@@notificationSettingsEmailShort:E-Mail`,
    title: $localize`:@@notificationSettingsEmail:E-Mail-Benachrichtigungen`,
    description: $localize`:@@notificationSettingsEmailDescription:Alle automatischen Benachrichtigungen per E-Mail.`,
  },
  {
    key: 'smsEnabled',
    icon: 'chat_bubble_outline',
    label: $localize`:@@notificationSettingsSmsShort:SMS`,
    title: $localize`:@@notificationSettingsSms:SMS-Benachrichtigungen`,
    description: $localize`:@@notificationSettingsSmsDescription:Alle automatischen Benachrichtigungen per SMS.`,
  },
  {
    key: 'notificationCenterEnabled',
    icon: 'notifications_none',
    label: centerLabel,
    title: centerLabel,
    description: $localize`:@@notificationSettingsCenterDescription:Neue Benachrichtigungen über die Glocke im Menü.`,
  },
] as const satisfies readonly {
  key: keyof EmployeeNotificationSettingsDto;
  icon: string;
  label: string;
  title: string;
  description: string;
}[];
